import { useLanguage } from "@/context/LanguageContext";

// Selector de idioma con banderas 🇺🇸 EN | 🇪🇸 ES
export default function LanguageSwitcher({ compact = false, className = "" }) {
  const { lang, setLang } = useLanguage();
  const base = "font-body text-sm tracking-wide transition-colors duration-200";
  return (
    <div data-testid="language-switcher" className={`flex items-center gap-2 ${className}`}>
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        aria-pressed={lang === "en"}
        className={`${base} ${lang === "en" ? "text-[color:inherit] font-semibold" : "opacity-55 hover:opacity-100"}`}
      >
        <span aria-hidden="true">🇺🇸</span> {compact ? "EN" : "English"}
      </button>
      <span aria-hidden="true" className="opacity-30">|</span>
      <button
        data-testid="lang-es"
        onClick={() => setLang("es")}
        aria-pressed={lang === "es"}
        className={`${base} ${lang === "es" ? "text-[color:inherit] font-semibold" : "opacity-55 hover:opacity-100"}`}
      >
        <span aria-hidden="true">🇪🇸</span> {compact ? "ES" : "Español"}
      </button>
    </div>
  );
}
